import React from "react";
import SocialIcons from "../../components/SocialIcons";

export const ServerError = () => {
    return (
        <>
        <h1>Oops! Something went wrong</h1>
        <p>Please reach out if this happens repeatedly. Your detailed feedback helps get things fixed faster</p>
        <SocialIcons />
        </>
    );
};